import { updateSurvey } from 'redux/slices/survey';

const updateSurveyStatus = async (check_survey, type, course_id = null) => {
  const { default: store } = await import('redux/store');
  const {dispatch } = store;
  dispatch(
    updateSurvey({check_survey, process: type, course_id })
  );
}

const USER_COURSE_STATUS_STAGES = {
  AWAITING_EVALUATION: 'awaiting_evaluation',
  APPROVED: 'approved',
  REPROBATE:  'reprobate'
}

export { updateSurveyStatus, USER_COURSE_STATUS_STAGES };